export default __webpack_public_path__ + "static/media/Cna.e773945d.jpg";